<div class="aoi-map">
  <div class="aoi-map__toolbar">
    <app-secondary-button
      title="Draw Polygon"
      icon="pi pi-pencil"
      size="small"
      [disable]="drawing()"
      (action)="startDraw()"
    ></app-secondary-button>
    <app-secondary-button
      title="Clear"
      icon="pi pi-times"
      size="small"
      (action)="clearPolygon()"
    ></app-secondary-button>
  </div>
  <div #mapHost class="aoi-map__canvas"></div>
</div>
